import base from './base.repository';


export default {
    ...base,
    saveAuthorization(authorization) {
        this.post(`authorizations`, authorization);
        return this;
    },
    loadAuthorizations(clientId, filters, page){
        const params = {...filters, page, client: clientId};
        this.get(`authorizations${this.querify(params)}`);
        return this;
    },
    deleteAuthorization(id){
        this.delete('authorizations/'+ id);
        return this;
    },
    uploadAuthorizationsFromExcel(payload){
        this.post('authorizations/upload-from-excel', payload);
        return this;
    },


}